import styled from 'styled-components'
import { Grid, Row } from 'react-styled-flexboxgrid-tmp'

export const _MenuPanel = styled.section`
  position: relative;
  z-index: 3;
  width: 100%;
`

export const _ContainerFluid = styled(Grid)`
  padding: 0 1rem;
`

export const _Row = styled(Row)`
  display: flex;
  justify-content: space-between;
  align-items: center;
  ul {
    justify-content: flex-end;
  }
`
